module.exports = __webpack_public_path__ + "img/banner-principal.0aa6f509.svg";